import { MyTableComponent, Input, TableModel, Button } from "components"
import { useEffect, useState } from "react"
import { Box } from "theme-ui"
import tittle from "./Tittle.png"
import selectIcon from "./selecticon.png"
import { useTranslation } from "react-i18next"
import { useDeviceJobElementsQuery } from "../../store/Features/devices/devicesJobElements-api-slice"

import { IJobElementsList, IJobElements } from "@types"

export const TaskElement = () => {
 const { t } = useTranslation("translation")
 const { data, isLoading } = useDeviceJobElementsQuery()

 const [allData, setAllData] = useState<IJobElements[]>([])
 const [currentData, setCurrentData] = useState<IJobElementsList[]>([])
 const [jobElements, setJobElements] = useState<IJobElementsList[]>([])
 const [modelData, setModelData] = useState<IJobElementsList>()
 const [currentIndex, setCurrentIndex] = useState<number>(0)
 const [popup, setPopup] = useState<boolean>(false)
 const [serverDeviceName, setServerDeviceName] = useState<string>()
 const [scrollVisible, setScrollVisible] = useState<boolean>()
 const [columnId, setColumnId] = useState<number>()
 const columns = [
  { Header: t("jobId"), accessor: "job_id" },
  { Header: t("timestamp"), accessor: "timestamp" },
  { Header: t("listNo"), accessor: "list_nr" },
  { Header: t("version"), accessor: "version" },
  {
   Header: "Status",

   Cell: ({ row }: any) => (
    <div className="flex items-center justify-center ">
     <svg
      className="cursor-pointer"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => {
       popHandler(row?.id), setScrollVisible(true)
       setColumnId(row?.id)
      }}
     >
      <g id="Iconly/Light-Outline/Danger Circle">
       <g id="Danger Circle">
        <path
         id="Fill 1"
         fillRule="evenodd"
         clipRule="evenodd"
         d="M12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z"
        />
        <path
         id="Fill 3"
         fillRule="evenodd"
         clipRule="evenodd"
         d="M11.9922 10.6269C11.5782 10.6269 11.2422 10.9629 11.2422 11.3769V15.7959C11.2422 16.2099 11.5782 16.5459 11.9922 16.5459C12.4062 16.5459 12.7422 16.2099 12.7422 15.7959V11.3769C12.7422 10.9629 12.4062 10.6269 11.9922 10.6269Z"
        />
        <path
         id="Fill 5"
         fillRule="evenodd"
         clipRule="evenodd"
         d="M12.005 7.2041C11.452 7.2041 11 7.6511 11 8.2041C11 8.7571 11.443 9.2041 11.995 9.2041H12.005C12.558 9.2041 13.005 8.7571 13.005 8.2041C13.005 7.6511 12.558 7.2041 12.005 7.2041Z"
        />
       </g>
      </g>
     </svg>
     {popup && (
      <Box bg="highlight">
       <div
        className={`fixed right-[12%] max-w-3xl min-w-[733px] max-h-[55vh] overflow-y-scroll z-10 ${
         row?.id == columnId ? "block" : "hidden"
        }`}
       >
        <div className="sticky top-0 drop-shadow-md">
         <Box bg="highlight" className="px-4 py-5 sm:p-6 sm:pb-4">
          <div className="flex justify-between w-full items-center ">
           <div className="sm:flex font-bold sm:items-start">
            {serverDeviceName && serverDeviceName}
           </div>
           <div>
            <Button
             size={"sm"}
             color={"white"}
             onClick={() => {
              setPopup(false)
             }}
            >
             Close
            </Button>
           </div>
          </div>
         </Box>
        </div>
        <Box bg="highlight" className="px-4 py-3 sm:px-4">
         <TableModel
          tableName="Ap Values"
          tableColumns={["Name", "Type", "Task Number", "Cycle Number", "Status"]}
          data={modelData?.details?.ap_values}
         />
         <TableModel
          tableName="Detectors"
          tableColumns={["Number", "Name", "Task Number", "Cycle Number", "Classif"]}
          data={modelData?.details?.detectors}
          spacingTop="mt-5"
         />

         <TableModel
          tableName="Signal Groups"
          tableColumns={["Number", "Name", "Task Number", "Cycle Number"]}
          data={modelData?.details?.signal_groups}
          spacingTop="mt-5"
         />
        </Box>
       </div>
      </Box>
     )}
    </div>
   ),
  },
 ]

 const popHandler = (id: number) => {
  setPopup(true)

  const newData = jobElements?.find((item, index) => index === Number(id))
  setModelData(newData)
 }
 useEffect(() => {
  if (data && currentIndex !== null) {
   setAllData(data)
   const newJobElements: any[] = []
   const _currentObject = data?.find((item: any, index: any) => index === currentIndex)
   setServerDeviceName(
    _currentObject?.common_information?.server_name +
     ": " +
     _currentObject?.common_information?.device_name,
   )
   newJobElements.push(_currentObject?.job_elements)

   setJobElements(newJobElements[0])
   setCurrentData(newJobElements[0])
  }
  // eslint-disable-next-line
 }, [data, currentIndex])

 const searchHandler = (keyword: any) => {
  if (keyword !== "") {
   const filterData: any = currentData?.filter((item: any) => {
    const itemString = String(item?.version).toLowerCase()
    return itemString.indexOf(keyword.toLowerCase()) !== -1
   })
   setJobElements([...filterData])
  } else {
   setJobElements(currentData)
  }
 }

 return (
  <div className="w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full">
   {popup && (
    <div className="fixed inset-0 z-10 w-screen overflow-y-scroll">
     <div className="fixed inset-0 top-5 bg-black bg-opacity-50 flex h-screen items-end justify-center p-4 text-center sm:items-center sm:p-0"></div>
    </div>
   )}
   <div className="flex justify-between mx-2 py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">{t("signalTimes")}</h1>
    <div className="flex lg:w-[6%] md:w-[8%] w-[15%] justify-between">
     <button className="bg-white h-6 w-6 rounded-lg flex items-center justify-center ">
      <img className="rotate-[-90deg]" src={selectIcon} alt="prev" />
     </button>
     <button className="bg-white h-6 w-6 rounded-lg flex items-center justify-center ">
      <img className="rotate-90" src={selectIcon} alt="next" />
     </button>
    </div>
   </div>
   <Box bg="highlight" color="text-black">
    <ul className="flex rounded w-[100%] Jakarta-font overflow-x-scroll hide-scroll-icon">
     {allData &&
      allData?.map((single, index) => (
       <li
        key={index}
        className={`text-xs bg-light-gray2 text-black opacity-70 cursor-pointer rounded px-2 py-3 lg:px-4 md:px-4 whitespace-nowrap  ${
         currentIndex === index ? "bg-white rounded font-bold" : ""
        }`}
        onClick={() => {
         setCurrentIndex(index)
        }}
       >
        {single?.common_information?.server_name} : {single?.common_information?.device_name}{" "}
       </li>
      ))}
    </ul>
    <div className="py-3 px-3 flex justify-between items-center">
     <h1 className="Jakarta-font font-semibold ">{serverDeviceName && serverDeviceName}</h1>

     <div className="flex items-center justify-end">
      <p className="Jakarta-font">{t("category")}</p>

      <div className="bg-white h-8 w-12  mx-4  border-light-gray border-[1.5px] rounded flex justify-center items-center">
       <img className="w-4" src={tittle} alt="tittlesign" />
      </div>

      {/* ======== SearchHandler  ======== */}
      <div className="w-1/4 hover:w-[45%] transition-all delay-150 duration-700">
       <Input
        onChange={searchHandler}
        className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2    "
        placeholder={t("search")}
        type="search"
       />
      </div>
     </div>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}

   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? jobElements : []}
    paginate={true}
    isLoading={isLoading}
    scrollVisible={scrollVisible}
   />
  </div>
 )
}
